// === SVG fetch+inject for county map ===
// Fetches si-county-map.svg and injects it into the DOM, then calls window.initSIMap()
// which is defined in the section's inline <script> and attaches all map event listeners.
document.addEventListener('DOMContentLoaded', function () {
  var placeholder = document.getElementById('si-map-svg-placeholder');
  if (!placeholder) return;
  var src = placeholder.getAttribute('data-src');
  fetch(src)
    .then(function (r) { return r.text(); })
    .then(function (svgText) {
      var tmp = document.createElement('div');
      tmp.innerHTML = svgText;
      var svgEl = tmp.querySelector('svg');
      if (svgEl) placeholder.parentNode.replaceChild(svgEl, placeholder);
      if (typeof window.initSIMap === 'function') window.initSIMap();
    })
    .catch(function (err) {
      console.warn('Social Impact: could not load county map SVG', err);
    });
});

// === US phone mask: formats input as (###) ###-#### ===
document.addEventListener('DOMContentLoaded', function () {
  var phone = document.getElementById('contact-phone');
  if (!phone) return;
  phone.addEventListener('input', function () {
    var digits = phone.value.replace(/\D/g, '').substring(0, 10);
    var result = '';
    if (digits.length > 0) result = '(' + digits.substring(0, 3);
    if (digits.length >= 4) result += ') ' + digits.substring(3, 6);
    if (digits.length >= 7) result += '-' + digits.substring(6, 10);
    phone.value = result;
  });
});

// === Contact form: show success modal when Shopify redirects back with ?charity_submitted=1 ===
document.addEventListener('DOMContentLoaded', function () {
  if (window.location.search.indexOf('charity_submitted=1') === -1) return;
  var modal = document.getElementById('charity-success-modal');
  if (!modal) return;
  modal.style.display = 'flex';
  document.body.style.overflow = 'hidden';
  history.replaceState(null, '', window.location.pathname);

  function closeModal() {
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }
  modal.addEventListener('click', function(e) { if (e.target === modal) closeModal(); });
  modal.querySelector('.csm-close').addEventListener('click', closeModal);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });
});
